import { CustomerTab } from '@/features/events/components/Detail/Tabs/CustomerTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/customer')({
  component: CustomerTab,
});
